import { TCString } from '@iabtechlabtcf/core';
import Papa from 'papaparse';
import './App.css';
import React, { useState } from 'react';

function App() {

  const [csvData, setCsvData] = useState([]);
  const [fileName, setFileName] = useState('');

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setFileName(getFileNameWithoutExtension(file.name));
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      complete: results => {
        setCsvData(results.data);
      }
    });
  };

  const handleDownloadCsv = () => {
    const output = csvData.filter(tcString => tcString.tc_string).map(tcString => {
      try {
        const decodedTCString = TCString.decode(tcString.tc_string);

        const formatedData = {
          version: decodedTCString?.version ?? '',
          created: decodedTCString?.created ?? '',
          last_updated: decodedTCString?.lastUpdated ?? '',
          cmp_id: decodedTCString?.cmpId ?? '',
          cmp_version: decodedTCString?.cmpVersion ?? '',
          consent_screen: decodedTCString?.consentScreen ?? '',
          consent_language: decodedTCString?.consentLanguage ?? '',
          vendor_list_version: decodedTCString?.vendorListVersion ?? '', 
          policy_version: decodedTCString?.policyVersion ?? '',
          is_service_specific: decodedTCString?.isServiceSpecific ?? '',
          use_non_standard_stacks: decodedTCString?.useNonStandardStacks ?? '',
          purpose_consents: decodedTCString?.purposeConsents?.set_?.size ?? 0,
          purpose_one_treatment: decodedTCString?.purposeOneTreatment ?? '',
          publisher_country_code: decodedTCString?.publisherCountryCode ?? '',
          vendor_consents: decodedTCString?.vendorConsents?.set_?.size ?? 0,
          publisher_restrictions: decodedTCString?.publisherRestrictions?.map?.size ?? 0
        }
  
        return { ...tcString, ...formatedData };
      } catch (error) {
        const formatedData = {
          version: 'incorrect tc string',
          created: 'incorrect tc string',
          last_updated: 'incorrect tc string',
          cmp_id: 'incorrect tc string',
          cmp_version: 'incorrect tc string',
          consent_screen: 'incorrect tc string',
          consent_language: 'incorrect tc string',
          vendor_list_version: 'incorrect tc string', 
          policy_version: 'incorrect tc string',
          is_service_specific: 'incorrect tc string',
          use_non_standard_stacks: 'incorrect tc string',
          purpose_consents: 'incorrect tc string',
          purpose_one_treatment: 'incorrect tc string',
          publisher_country_code: 'incorrect tc string',
          vendor_consents: 'incorrect tc string',
          publisher_restrictions: 'incorrect tc string'
        }
  
        return { ...tcString, ...formatedData };
      }
    });

    const csv = Papa.unparse(output);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", `${fileName}_decoded.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getFileNameWithoutExtension = (fileName) => {
    return fileName.split('.').slice(0, -1).join('.');
  };

  return (
    <div className="App">
      <h1>TC String Converter</h1>
      <input type="file" accept=".csv" onChange={handleFileUpload} className='large-button' />
      <button onClick={handleDownloadCsv} className='large-button'>Konwertuj plik</button>
    </div>
  );
}

export default App;
